import { Component } from 'react'
import { Oval } from 'react-loader-spinner'
import {authenticatedFetch} from '../../utils/authenticatedFetch'
import { FiFilter, FiGrid, FiList } from 'react-icons/fi'

import ProductCard from '../ProductCard'
import TopFilterBar from '../TopFilterBar'
import FilterDrawer from '../FilterDrawer'
import ActiveFilterChips from '../ActiveFilterChips'

import './index.css'

const categoryOptions = [
  { name: 'Clothing', categoryId: '1' },
  { name: 'Electronics', categoryId: '2' },
  { name: 'Appliances', categoryId: '3' },
  { name: 'Grocery', categoryId: '4' },
  { name: 'Toys', categoryId: '5' },
]

const sortbyOptions = [
  { optionId: 'PRICE_HIGH', displayText: 'Price (High-Low)' },
  { optionId: 'PRICE_LOW', displayText: 'Price (Low-High)' },
]

const ratingsList = [
  { ratingId: '4', imageUrl: 'https://assets.ccbp.in/frontend/react-js/rating-four-stars-img.png' },
  { ratingId: '3', imageUrl: 'https://assets.ccbp.in/frontend/react-js/rating-three-stars-img.png' },
  { ratingId: '2', imageUrl: 'https://assets.ccbp.in/frontend/react-js/rating-two-stars-img.png' },
  { ratingId: '1', imageUrl: 'https://assets.ccbp.in/frontend/react-js/rating-one-star-img.png' },
]

const apiStatusConstants = {
  initial: 'INITIAL',
  success: 'SUCCESS',
  failure: 'FAILURE',
  inProgress: 'IN_PROGRESS',
}

class AllProductsSection extends Component {
  state = {
    productsList: [],
    apiStatus: apiStatusConstants.initial,
    activeOptionId: sortbyOptions[0].optionId,
    activeCategoryId: '',
    searchInput: '',
    activeRatingId: '',
    isDrawerOpen: false,
    viewMode: 'grid',
  }

  componentDidMount() {
    this.getProducts()
  }

  getProducts = async () => {
    this.setState({ apiStatus: apiStatusConstants.inProgress })
    const {
      activeOptionId,
      activeCategoryId,
      searchInput,
      activeRatingId,
    } = this.state
    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/products?sort_by=${activeOptionId}&category=${activeCategoryId}&title_search=${searchInput}&rating=${activeRatingId}`
    const options = {
      method: 'GET',
    }
    const response = await authenticatedFetch(apiUrl, options)
    if (response.ok) {
      const fetchedData = await response.json()
      const updatedData = fetchedData.products.map(product => ({
        title: product.title,
        brand: product.brand,
        price: product.price,
        id: product.id,
        imageUrl: product.image_url,
        rating: product.rating,
      }))
      this.setState({
        productsList: updatedData,
        apiStatus: apiStatusConstants.success,
      })
    } else {
      this.setState({ apiStatus: apiStatusConstants.failure })
    }
  }

  renderLoadingView = () => (
    <div className="products-loader-container">
      <Oval color="#0b69ff" height={50} width={50} />
    </div>
  )

  renderFailureView = () => (
    <div className="products-error-view-container">
      <img
        src="https://assets.ccbp.in/frontend/react-js/nxt-trendz/nxt-trendz-products-error-view.png"
        alt="all-products-error"
        className="products-failure-img"
      />
      <h1 className="product-failure-heading-text">Oops! Something Went Wrong</h1>
      <p className="products-failure-description">
        We are having some trouble processing your request. Please try again.
      </p>
    </div>
  )

  changeSortby = activeOptionId => {
    this.setState({ activeOptionId }, this.getProducts)
  }

  renderProductsListView = () => {
    const { productsList, viewMode } = this.state
    const shouldShowProductsList = productsList.length > 0

    return shouldShowProductsList ? (
      <div className="all-products-container">
        <ul className={`products-list ${viewMode}`}>
          {productsList.map(product => (
            <ProductCard productData={product} key={product.id} viewMode={viewMode} />
          ))}
        </ul>
      </div>
    ) : (
      <div className="no-products-view">
        <img
          src="https://assets.ccbp.in/frontend/react-js/nxt-trendz/nxt-trendz-no-products-view.png"
          className="no-products-img"
          alt="no products"
        />
        <h1 className="no-products-heading">No Products Found</h1>
        <p className="no-products-description">
          We could not find any products. Try other filters.
        </p>
      </div>
    )
  }

  renderAllProducts = () => {
    const { apiStatus } = this.state
    switch (apiStatus) {
      case apiStatusConstants.success:
        return this.renderProductsListView()
      case apiStatusConstants.failure:
        return this.renderFailureView()
      case apiStatusConstants.inProgress:
        return this.renderLoadingView()
      default:
        return null
    }
  }

  clearFilters = () => {
    this.setState(
      {
        searchInput: '',
        activeCategoryId: '',
        activeRatingId: '',
      },
      this.getProducts,
    )
  }

  changeRating = activeRatingId => {
    this.setState({ activeRatingId }, this.getProducts)
  }

  changeCategory = activeCategoryId => {
    this.setState({ activeCategoryId }, this.getProducts)
  }

  enterSearchInput = () => {
    this.getProducts()
  }

  changeSearchInput = searchInput => {
    this.setState({ searchInput })
  }

  renderMobileActionToolbar = () => {
    const { viewMode, activeOptionId, activeCategoryId, activeRatingId, searchInput } = this.state
    const activeFiltersCount = (activeCategoryId ? 1 : 0) + (activeRatingId ? 1 : 0) + (searchInput ? 1 : 0)
    
    return (
      <div className="mobile-action-toolbar">
        <button className="mobile-filter-btn" onClick={() => this.setState({ isDrawerOpen: true })}>
          <FiFilter /> Filters 
          {activeFiltersCount > 0 && <span className="filter-badge">{activeFiltersCount}</span>}
        </button>
        <div className="mobile-toolbar-right">
          <select 
            value={activeOptionId} 
            onChange={(e) => this.changeSortby(e.target.value)}
            className="mobile-sort-select"
          >
            {sortbyOptions.map(option => (
              <option key={option.optionId} value={option.optionId}>{option.displayText}</option>
            ))}
          </select>
          <div className="view-mode-toggles">
            <button 
              className={`view-btn ${viewMode === 'grid' ? 'active' : ''}`} 
              onClick={() => this.setState({ viewMode: 'grid' })}
              title="Grid View"
            >
              <FiGrid />
            </button>
            <button 
              className={`view-btn ${viewMode === 'list' ? 'active' : ''}`} 
              onClick={() => this.setState({ viewMode: 'list' })}
              title="List View"
            >
              <FiList />
            </button>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const {
      activeCategoryId,
      searchInput,
      activeRatingId,
      activeOptionId,
      isDrawerOpen,
    } = this.state

    const filterProps = {
      searchInput,
      categoryOptions,
      ratingsList,
      sortbyOptions,
      activeCategoryId,
      activeRatingId,
      activeOptionId,
      changeSearchInput: this.changeSearchInput,
      enterSearchInput: this.enterSearchInput,
      changeCategory: this.changeCategory,
      changeRating: this.changeRating,
      changeSortby: this.changeSortby,
      clearFilters: this.clearFilters,
    }

    return (
      <div className="all-products-section">
        <div className="promo-strip">
          <p>Get Prime for Free Shipping on all orders!</p>
        </div>

        <TopFilterBar {...filterProps} />
        
        <FilterDrawer 
          isOpen={isDrawerOpen} 
          onClose={() => this.setState({ isDrawerOpen: false })} 
          {...filterProps} 
        />
        
        <div className="products-content-wrapper">
          {this.renderMobileActionToolbar()}
          <ActiveFilterChips {...filterProps} />
          {this.renderAllProducts()}
        </div>
      </div>
    )
  }
}

export default AllProductsSection
